import {memo, useCallback, useMemo} from "react";
import {GenerationStatusEnum} from "../shared/types/GenerationStatusEnum.ts";
import {GeneratedGalleryCard} from "../shared/ui/GeneratedGalleryCard.tsx";
import {ProcessingGalleryCard} from "../shared/ui/ProcessingGalleryCard.tsx";
import {FailedGalleryCard} from "../shared/ui/FailedGalleryCard.tsx";
import {useAppDispatch} from "../app/store/hooks";
import {setFullscreenPreview} from "../app/store/slices/appSlice";
import {ICompletedGeneration, IFailedGeneration, IProcessingGeneration} from "../shared/types/GenerationType.ts";


interface IGalleryCardProps {
    generation: ICompletedGeneration | IProcessingGeneration | IFailedGeneration;
}

export const GalleryCard = memo(({generation}: IGalleryCardProps) => {
    const dispatch = useAppDispatch();

    const handleClick = useCallback(() => {
        dispatch(setFullscreenPreview(generation));
    }, [dispatch, generation]);


    const content = useMemo(() => {
        switch (generation.status) {
            case GenerationStatusEnum.GENERATED:

                return <GeneratedGalleryCard src={generation.previewSrc} alt={'result'} onClick={handleClick}
                                             type={"image"}/>

            case GenerationStatusEnum.PROCESSING:
                return <ProcessingGalleryCard onClick={handleClick}/>;
            case GenerationStatusEnum.FAILED:
                return <FailedGalleryCard onClick={handleClick}/>;
            default:
                return null;
        }
    }, [handleClick]);

    return content;
});
